import { useState } from "react";
import { useDashboard } from "../../context/DashboardContext";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { CalendarDays, Check } from "lucide-react";

const PRESETS = [
  { key: "7d", label: "Last 7 days" },
  { key: "30d", label: "Last 30 days" },
  { key: "90d", label: "Last 90 days" },
  { key: "month", label: "This month" },
];

export default function DateRangePicker() {
  const { preset, applyPreset, range, setCustom } = useDashboard();
  const [open, setOpen] = useState(false);
  const [cs, setCs] = useState(range.start);
  const [ce, setCe] = useState(range.end);

  const label = preset === "custom"
    ? `${range.start} → ${range.end}`
    : PRESETS.find((p) => p.key === preset)?.label || "Date range";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="date-range-btn"
          className="flex items-center gap-2 h-9 px-3 rounded-full bg-[#1E293B] border border-white/10 hover:bg-[#334155] transition-colors text-xs text-slate-200">
          <CalendarDays className="w-3.5 h-3.5 text-[#38BDF8]" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 bg-[#1E293B] border-white/10 text-slate-200 p-2">
        <div className="space-y-1">
          {PRESETS.map((p) => (
            <button key={p.key} data-testid={`preset-${p.key}`}
              onClick={() => { applyPreset(p.key); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors ${
                preset === p.key ? "bg-[#38BDF8]/15 text-[#38BDF8]" : "hover:bg-[#334155] text-slate-300"}`}>
              {p.label}
              {preset === p.key && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
        <div className="border-t border-white/10 mt-2 pt-2 space-y-2">
          <p className="text-xs uppercase tracking-wider text-slate-500 px-1">Custom range</p>
          <div className="flex gap-2">
            <Input data-testid="custom-start" type="date" value={cs} onChange={(e) => setCs(e.target.value)}
              className="h-8 bg-[#0F172A] border-white/10 text-white text-xs" />
            <Input data-testid="custom-end" type="date" value={ce} onChange={(e) => setCe(e.target.value)}
              className="h-8 bg-[#0F172A] border-white/10 text-white text-xs" />
          </div>
          <Button data-testid="apply-custom-range" onClick={() => { setCustom(cs, ce); setOpen(false); }}
            className="w-full h-8 bg-[#38BDF8] hover:bg-[#0EA5E9] text-[#0F172A] font-semibold rounded-lg text-xs">
            Apply
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
